import { HOME } from "@/constants/testIds";

const packages = [
    {
        name: "Chikmagalur Coffee Escape",
        days: "3 Days · 2 Nights",
        price: "from ₹6,999",
        img: "https://images.unsplash.com/photo-1648035376406-233db3029aee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHx3ZXN0ZXJuJTIwZ2hhdHMlMjBrYXJuYXRha2ElMjB0cmF2ZWx8ZW58MHx8fHwxNzg1Mzg5MTE5fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Agumbe Rainforest Trail",
        days: "2 Days · 1 Night",
        price: "from ₹4,499",
        img: "https://images.unsplash.com/photo-1707302531458-96652c96c20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHx3ZXN0ZXJuJTIwZ2hhdHMlMjBrYXJuYXRha2ElMjB0cmF2ZWx8ZW58MHx8fHwxNzg1Mzg5MTE5fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Jog Falls & Sirsi Backwaters",
        days: "4 Days · 3 Nights",
        price: "from ₹8,299",
        img: "https://images.unsplash.com/photo-1729678426987-443dcb81fd2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHx3ZXN0ZXJuJTIwZ2hhdHMlMjBrYXJuYXRha2ElMjB0cmF2ZWx8ZW58MHx8fHwxNzg1Mzg5MTE5fDA&ixlib=rb-4.1.0&q=85",
    },
];

const Packages = () => {
    return (
        <section id="packages" className="mx-auto max-w-7xl px-5 md:px-10 py-24">
            <div className="flex items-end justify-between gap-6 mb-12">
                <div>
                    <p className="text-xs uppercase tracking-[0.28em] text-[#C46A42] font-medium">
                        Curated escapes
                    </p>
                    <h2 className="font-display text-4xl md:text-6xl text-[#1B3B2B] mt-3 max-w-2xl leading-[1.05]">
                        Handpicked packages, fair prices.
                    </h2>
                </div>
                <p className="hidden md:block max-w-sm text-[#4B5563]">
                    From misty coffee estates to golden beaches — every trip
                    planned end to end, so you only carry memories.
                </p>
            </div>

            <div className="grid gap-6 md:grid-cols-3">
                {packages.map((p, i) => (
                    <a
                        key={i}
                        href="#plan"
                        data-testid={`${HOME.pkgCard}-${i}`}
                        className="pkg-card group block overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-black/5 hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
                    >
                        <div className="aspect-[4/5] overflow-hidden">
                            <img
                                src={p.img}
                                alt={p.name}
                                className="h-full w-full object-cover"
                            />
                        </div>
                        <div className="p-5">
                            <div className="text-xs uppercase tracking-[0.2em] text-[#4B5563]">
                                {p.days}
                            </div>
                            <div className="mt-2 font-display text-2xl text-[#1B3B2B]">
                                {p.name}
                            </div>
                            <div className="mt-3 text-sm text-[#C46A42] font-medium">
                                {p.price}
                            </div>
                        </div>
                    </a>
                ))}
            </div>
        </section>
    );
};

export default Packages;
